import React from 'react';
import SubscriptionPlans from '../../../../shared/SubscriptionCheckout/SubscriptionPlans/SubscriptionPlans';
import useGetAgentCheckoutLinks from '../../../../Hooks/Agent/Getters/useGetAgentCheckoutLinks/useGetAgentCheckoutLinks';
import useGetAgentSubscription from '../../../../Hooks/Agent/Getters/useGetAgentSubscription/useGetAgentSubscription';
import tiers from './subscriptionTiersData';

/** @returns {JSX.Element} */
export default function Checkout() {
	const checkoutLinks = useGetAgentCheckoutLinks();
	const subscriptionData = useGetAgentSubscription();

	return (
		<section className="pt-6">
			<SubscriptionPlans
				checkoutRole="agent"
				isGettingData={checkoutLinks.isGettingData}
				paymentLinks={checkoutLinks.data}
				subscription={subscriptionData.data}
				tiers={tiers}
			/>
		</section>
	);
}
